module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_c('a', {
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('p', {
    staticClass: "tocfront"
  }, [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('a', {
    attrs: {
      "id": "rintro"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04_introd#intro"
    }
  }, [_c('strong', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfront"
  }, [_c('a', {
    attrs: {
      "id": "ringre"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05_ingredients#ingre"
    }
  }, [_c('strong', [_vm._v("Ingredients")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfront"
  }, [_c('a', {
    attrs: {
      "id": "requi"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06_equipment#equi"
    }
  }, [_c('strong', [_vm._v("Equipment")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    attrs: {
      "id": "rch01"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07_chapter1#ch01"
    }
  }, [_vm._v("1 Sticky, Chewy Chocolate")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch01sec1"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07_chapter1#ch01sec1"
    }
  }, [_vm._v("Heart of Darkness Brownies")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch01sec2"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07_chapter1#ch01sec2"
    }
  }, [_vm._v("Dark Chocolate Soup with Cinnamon-Toasted Pound-Cake Croutons")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch01sec3"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07_chapter1#ch01sec3"
    }
  }, [_vm._v("Outrageously Thick Spanish Hot Chocolate with Churros")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch01sec4"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07_chapter1#ch01sec4"
    }
  }, [_vm._v("Triple-Layer Chocolate Silk Martini")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch01sec5"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07_chapter1#ch01sec5"
    }
  }, [_vm._v("The Best One-Bowl Chocolate Chunk–Pecan Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch01sec6"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07_chapter1#ch01sec6"
    }
  }, [_vm._v("Chocolate Mascarpone Cheesecake Pots with Shortbread Spoons")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch01sec7"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07_chapter1#ch01sec7"
    }
  }, [_vm._v("Chocolate-Mayonnaise Cupcakes with Caramel-Butterscotch Buttercream Frosting")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch01sec8"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07_chapter1#ch01sec8"
    }
  }, [_vm._v("White and Dark Chocolate Fondue with Coconut Madeleines and Homemade Marshmallows")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch01sec9"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07_chapter1#ch01sec9"
    }
  }, [_vm._v("Grilled Chocolate Pound-Cake Sandwiches à la Mode")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch01sec10"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07_chapter1#ch01sec10"
    }
  }, [_vm._v("All-Grown-Up S’mores")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch01sec11"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07_chapter1#ch01sec11"
    }
  }, [_vm._v("Chocolate Caramel-Pecan Soufflé Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch01sec12"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07_chapter1#ch01sec12"
    }
  }, [_vm._v("Black Bottom Cupcakes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch01sec13"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07_chapter1#ch01sec13"
    }
  }, [_vm._v("Mountain Meadow Chocolate Fudge Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch01sec14"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07_chapter1#ch01sec14"
    }
  }, [_vm._v("Sticky Fingers Triple-Chocolate Ice-Cream Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch01sec15"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07_chapter1#ch01sec15"
    }
  }, [_vm._v("Chocolate Malted Madness")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch01sec16"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07_chapter1#ch01sec16"
    }
  }, [_vm._v("Sugar-Crusted Brownie Sundaes with Whiskey-Walnut Caramel Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    attrs: {
      "id": "rch02"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08_chapter2#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 The Pudding Club")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch02sec1"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08_chapter2#ch02sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butterscotch Pots")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch02sec2"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08_chapter2#ch02sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep, Dark Chocolate Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch02sec3"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08_chapter2#ch02sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sticky Toffee Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch02sec4"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08_chapter2#ch02sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christmas Pudding with Brandied Hard Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch02sec5"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08_chapter2#ch02sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana Bread Pudding with Hot Fudge and Toasted Walnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch02sec6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08_chapter2#ch02sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Croissant Bread Pudding with Hot “Glava” Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch02sec7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08_chapter2#ch02sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rich Risotto Rice Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch02sec8"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08_chapter2#ch02sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cinnamon-Donut Bread Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch02sec9"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08_chapter2#ch02sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eton Mess")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch02sec10"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08_chapter2#ch02sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coconut Milk–Cream Cheese Flan")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch02sec11"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08_chapter2#ch02sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Pink Grapefruit–Tangerine Mousse with Crispy Phyllo Ruffles")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch02sec12"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08_chapter2#ch02sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mocha Hazelnut Trifle with Kahlúa Whipped Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    attrs: {
      "id": "rch03"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Cookies, Cakes & Pies Oh My!")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec1"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chewy Date Bars")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec2"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nutty Coconut Macaroons")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec3"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blackberry Jamble Shortbread Bars")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec4"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gooey Caramel Butter Bars")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec5"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Big Blondes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Everything-but-the-Kitchen-Sink Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crispy Oatmeal Florentines with Peanut Butter–Caramel Filling")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec8"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chewy Lemon-Pistachio Financiers")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec9"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honey Caramel-Pecan Phyllo Slices")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec10"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sticky Pear and Walnut Upside-Down Gingerbread")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec11"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mama’s Merry Christmas Meringues")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec12"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ooh! Brown Sugar! and Almond Pound Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec13"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec14"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Walnut Torte with Dark Rum Syrup")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec15"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Devil’s Food Cake with Chocolate Mousse Buttercreammm")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec16"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bahama Mama Banana Rum Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec17"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brown-Butter Almond Cake with Caramel Apples")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec18"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maple Walnut Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec19"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Double-Crumble Hot Apple Pies")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec20"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butterscotch-Bourbon Macadamia Nut Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec21"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banoffee Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec22"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not-So-Angelic Angel Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch03sec23"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_chapter3#ch03sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Perfect Pie Crust")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    attrs: {
      "id": "rch04"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_chapter4#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Do Try This at Home! Over-the-Top Treats for the Kid in All of Us")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch04sec1"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_chapter4#ch04sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New York Cheesecake Milkshake")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch04sec2"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_chapter4#ch04sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesecake Pops")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch04sec3"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_chapter4#ch04sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milky Way Tempura-on-a-Stick")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch04sec4"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_chapter4#ch04sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quicky Sticky Biscuits")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch04sec5"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_chapter4#ch04sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scotchmallow Ice-Cream Sundae")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch04sec6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_chapter4#ch04sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dirty Banana Sundae")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch04sec7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_chapter4#ch04sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wafer-Thin-Mint Sundae with Bittersweet Peppermint Ganache")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch04sec8"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_chapter4#ch04sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Trash Panini")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch04sec9"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_chapter4#ch04sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Giant Coconut Cream Puffs")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch04sec10"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_chapter4#ch04sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heaven-on-a-Stick")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch04sec11"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_chapter4#ch04sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cap’n Crunch Crispy Treats")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch04sec12"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_chapter4#ch04sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Pecan Pralines")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch04sec13"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_chapter4#ch04sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingersnap Dulce de Leche Ice-Cream Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch04sec14"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_chapter4#ch04sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salted Cashew Toffee")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch04sec15"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_chapter4#ch04sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raspberry-Rhubarb Monte Cristo Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch04sec16"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_chapter4#ch04sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sugared Stuffed Dates")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch04sec17"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_chapter4#ch04sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep-Dish Baklava")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('a', {
    attrs: {
      "id": "rch04sec18"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_chapter4#ch04sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hawaiian Caramel Corn")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('a', {
    attrs: {
      "id": "rindex"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11_index#index",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('a', {
    attrs: {
      "id": "rsources"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_sources#sources",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Sources")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('a', {
    attrs: {
      "id": "rtable"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_table#table",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Table of Equivalents")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b9996b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03_toc.vue
// module id = 72
// module chunks = 0